import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'db-domains-table',
    templateUrl: './domains-table.component.html',
    styleUrls: ['./domains-table.component.scss'],
    standalone: false
})
export class DomainsTableComponent implements OnInit {
  isMobile = window.innerWidth <= 1024;
  public heads: string[] = ['text_addZoneDomainHint', 'text_status', 'text_actionsColumn'];

  @Input() listLoading = false;
  @Input() checkStatusesLoading = false;
  @Output() reloadDomainsEvent = new EventEmitter<void>();

  constructor() {
  }

  ngOnInit() {
  }

  reloadDomains() {
    this.reloadDomainsEvent.emit();
  }

  @HostListener('window:resize') resize() {
    this.isMobile = window.innerWidth <= 1024;
  }
}
